import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "title is-4" }, "Remaining Evidence", -1)
const _hoisted_2 = { class: "table is-hoverable" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Evidence"),
    /*#__PURE__*/_createElementVNode("th", null, "Probability")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.probabilities, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.evidence
          }, [
            _createElementVNode("td", null, _toDisplayString(item.evidence), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.round(item.probability, 2).toLocaleString()) + "%", 1)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}